export const educationData = [
  {
    year: '2024 - 2025',
    title: 'Higher National Diploma in Software Engineering',
    institution: 'National Institute of Business Management (NIBM)',
    description: 'Focus on software development, programming, database management, and systems design.',
  },
  {
    year: '2023 - 2024',
    title: 'Diploma in Software Engineering',
    institution: 'National Institute of Business Management (NIBM)',
    description: 'Hands-on experience with software engineering techniques, tools, and project-based development.',
  },
];

export const experienceData = [
  {
    year: 'Jan 2023 - Present',
    title: 'Full Stack Engineer & Business Systems Developer',
    institution: 'Independent / Self-Directed',
    description: 'Built and deployed full-stack business platforms including a dealership management system and a multi-tenant contractor SaaS. Covered auth, RBAC, dashboards, reporting, AI integration, and cloud deployment.',
  },
  {
    year: '2019 - Present',
    title: 'Freelance Website, SEO & Ecommerce Assistant',
    institution: 'Self-Directed / Freelance',
    description: 'Managed website and ecommerce store operations across Shopify, WordPress and Wix. Handled product uploads, on-page SEO, meta titles and descriptions, Google Search Console, social media content, basic Meta Ads, and email marketing via Klaviyo and Mailchimp.',
  },
];
